<template>
  <div class="order-record">
    <my-header title="Order record"></my-header>
    <div class="record-list">
      <div class="item flex" v-for="item in orderList" :key="item.id">
        <div class="left flex column">
          <div class="left-top flex">
              <div class="symbol">{{item.currency | rename}}</div>
              <div> 
                <div class="buy up" v-if="item.orderContent=='2'">Buy Up</div>
                <div class="buy down" v-if="item.orderContent=='1'">Buy fall</div>
              </div>
              <div class="count" v-show="item.settleTime">
                <div class="amount">{{item.priceSpread}}</div>
                <div class="percent">{{item.priceSpreadRate}}%</div>
              </div>
          </div>
          <div class="row">
            <div class="col">{{item.price1}}</div>
            <div class="col">Investment</div>
          </div>
          <div class="row">
            <div class="col">Entry price</div>
            <div class="col">{{item.amount}}{{item.currency | rename}}</div>
          </div>
          <div class="row" v-show="item.settleTime">
            <div class="col">{{item.price2}}</div>
          </div>
        </div>
        <div class="right">
          <div class="multiple">{{item.multiple}}X</div>
          <div class="tit" v-show="item.settleTime">Porfit and loss</div>
          <div class="change" v-show="item.settleTime" :class="item.profit>0?'green':'red'">{{item.profit}}{{item.currency | rename}}</div>
          <div class="dollar" v-show="item.settleTime" :class="item.profit>0?'green':'red'">≈{{item.billed_value}}$</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from '@/components/MyHeader.vue';
import { getOrderRecord } from "../http/api"

export default {
  components: { MyHeader },
  name: "orderRecord",
  data() {
    return {
      orderList:[]
    };
  },
  filters:{
    rename(val){
      if(val){
        return val.replace("USDT","")
      }else{
        return val
      }
    }
  },
  async created() {
    this.$loading.show()
    const res = await getOrderRecord();
    if(res && res.data){
      console.log(res);
      this.$loading.hide();
      this.orderList = res.data;
    }
  },
  methods: {
    
  }
};
</script>

<style lang="less" scoped>
.order-record{
  .record-list{
    background-color: #fff;
    height: calc(100vh - 40px);
    overflow-y: scroll;
    .item{
      padding: 20px;
      border-bottom: 1px solid #eee;
      .left{
        min-width: 70%;
        .left-top{
          margin-bottom: 4px;
          .symbol{
            margin-top: 8px;
            margin-right: 16px;
            font-weight: bold;
          }
          .buy{
            margin-top: 8px;
            display: inline-block;
            height: 20px;
            line-height: 20px;
            padding: 0 10px;
            border-radius: 3px;
            margin-right: 16px;
            &.up{
              background-color: green;
              color: #fff;
            }
            &.down{
              background-color: red;
              color: #fff;
            }
          }
          .count{
            font-size: 12px;
          }
        }
        .row{
          display: flex;
          .col{
            flex-grow: 1;
            font-size: 12px;
          }
        }
      }
      .right{
        .multiple{
          font-weight: bold;
          margin-bottom: 8px;
        }
        .tit{
          font-size: 12px;
          margin-bottom: 6px;
        }
        .change,.dollar{
          font-size: 12px;
          &.red{
            color: red;
          }
          &.green{
            color: green;
          }
        }
      }
    }
  }
}
</style>